module.exports = __webpack_public_path__ + "img/DinaCard.97cfa745.jpg";